import apiService from '../apiService';
const SUPER_ADMIN_URL = '/super-admin'
const profileService = {
  // Normal Admin / Tenant
  async getProfile() {
    try {
      const response = await apiService.get(`/settings/profile`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateProfile(payload) {
    try {
      const response = await apiService.post(`/settings/profile`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async resetPassword(payload) {
    try {
      const response = await apiService.post(`/settings/profile/reset-password`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  // Super Admin
  async superAdminGetProfile() {
    try {
      const response = await apiService.get(`${SUPER_ADMIN_URL}/profile`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminUpdateProfile(payload) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/profile`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async superAdminResetPassword(payload) {
    try {
      const response = await apiService.post(`${SUPER_ADMIN_URL}/profile/reset-password`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default profileService;